module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "运行中作业分片查看",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "190px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Executor"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.runningAllocationInfo.executorName))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运行中作业分片"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.runningAllocationInfo.runningJobItems).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.runningAllocationInfo.runningJobItems)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags",
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("可能运行中的作业分片")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": "作业状态未上报，无法获知运行状态，例如消息作业和秒级作业",
      "effect": "light",
      "popper-class": "allocation-popper"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.runningAllocationInfo.potentialRunningJobItems).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.runningAllocationInfo.potentialRunningJobItems)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags",
      attrs: {
        "type": "warning"
      }
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8bc3fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/running_allocation_dialog.vue
// module id = 1413
// module chunks = 1